'use client'
import { createContext } from 'react'
import type { OverridesContextType } from './types'

export const OverridesContext = createContext<OverridesContextType | null>(null)
